import { RealtimeClient } from "./RealtimeClient";
import { RestClient } from "./restClient";

export class ActivityService {
	constructor(options) {
		this._options = options;
		this._rc = new RealtimeClient();
		this._restClient = new RestClient();
	}

	subscribeByTarget(targetId, targetEntityType, filterOptions, callback) {
		const args = {
			targetId: targetId,
			targetType: targetEntityType,
			filterType: "by-target"
		};

		if (filterOptions) {
			if (filterOptions.types) args.types = filterOptions.types;
			if (filterOptions.private) args.private = filterOptions.private;
		}

		return this._rc.subscribe("ecosystem", "/activities", args, function (msg) {
			const response = JSON.parse(msg);
			if (response) {
				if (callback) {
					callback(null, response);
				}
			}
		});
	}

	// Actual activities, not user stream
	subscribeByEvent(eventId, targetEntityType, initialPageSize, filterOptions, callback) {
		const args = {
			targetId: eventId,
			targetType: targetEntityType,
			filterType: "by-event",
			initialPageSize: initialPageSize
		};

		if (filterOptions) {
			if (filterOptions.types) args.types = filterOptions.types;
			if (filterOptions.private) args.private = filterOptions.private;
		}

		return this._rc.subscribe("ecosystem", "/activities", args, function (msg) {
			const response = JSON.parse(msg);
			if (response) {
				if (callback) {
					callback(null, response);
				}
			}
		});
	}

	getActivitiesByEntity(entityType, entityId, pageSize, fromDate, filterOptions, callback) {
		let url = `/ecosystem/api/activities?entityType=${entityType}&entityId=${entityId}&fromDate=${fromDate}&pagesize=${pageSize}`;
		if (filterOptions) {
			if (filterOptions.types) url += `&types=${filterOptions.types.join(",")}`;
			if (filterOptions.private) url += `&private=${filterOptions.private}`;
		}
		this._restClient.exec_get(url, callback);
	}

	getActivitiesByEvent(eventId, pageSize, fromDate, filterOptions, callback) {
		// cSpell:ignore eventid
		let url = `/ecosystem/api/activities?eventid=${eventId}&fromDate=${fromDate}&pagesize=${pageSize}`;
		if (filterOptions) {
			if (filterOptions.types) url += `&types=${filterOptions.types.join(",")}`;
			if (filterOptions.private) url += `&private=${filterOptions.private}`;
		}
		this._restClient.exec_get(url, callback);
	}

	comment(entityId, entityType, comment, callback) {
		const url = `/ecosystem/api/activities/${entityId}/comment`;
		const body = JSON.stringify({
			comment: comment,
			entityType: entityType
		});
		this._restClient.exec_post(url, body, callback);
	}

	getActivityDetails(id, callback) {
		const url = `/ecosystem/api/activities/${id}`;
		this._restClient.exec_get(url, callback);
	}
}
